import React, { useState } from "react";
import classes from "./CreateInvestmentsModal.module.css";
import Modal from "components/common/Modal/Modal";
import { Button, Input, Text } from "components/common";

import clsx from "clsx";
import Checkbox from "components/common/CheckBox/CheckBox";
import { handleKeyDown } from "hooks";
import { toast } from "react-toastify";
import { open_position } from "helpers/api/apis";

const CreateInvestmentsModal = ({ setAmount, amount, isActive, position, onClose, onClick, userData, el, setNewInvestment, setShowTransactionDetailsModal, showTransactionDetailsModal }) => {
  console.log(userData, "userData"); 
  
  let balance = userData?.balance;
  const [agreeToPolicy, setAgreeToPolicy] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const depositInfo = [
    {
      key: "Min. Deposit",
      value: position?.minimum_amount,
    },
    {
      key: "Max. Deposit",
      value: position?.maximum_amount,
    },
    // {
    //   key: "Duration",
    //   value: position?.duration + " " +
    //     position.duration_in.toLowerCase() === "days" && position.duration === 1 ? "day"
    //     : position.duration_in.toLowerCase() === "days" ? "days"
    //       : position.duration_in.toLowerCase() === "weeks" && position.duration === 1 ? "week"
    //         : position.duration_in.toLowerCase() === "weeks" ? "weeks"
    //           : position.duration_in.toLowerCase() === "months" && position.duration === 1 ? "month"
    //             : position.duration_in.toLowerCase() === "months" ? "months"
    //               : ""
    //   ,
    // },
    {
      key: "Balance",
      value: (balance || 0) + " USD",
      isBalance: true
    },
  ];
  return (
    <>
      <Modal isActive={isActive} onClose={onClose} heading="Create Investments">
        <div className={classes.wrapper}>
          <div className={classes.header}>
            <Text primitive600 base>
              <span className={classes.note}>Note:</span> You can only invest up to your available balance.
            </Text>
          </div>
          <Text lg primitive950>
            You have selected{" "}
            <span className={classes.plan}>{position?.id}</span> investments
            plan.
          </Text>

          <div className={classes.depositInfo}>
            {depositInfo?.map((info, index) => (
              <div className={classes.spaceBetween} key={index}>
                <Text className={classes.key} primitive700 base>
                  {info.key}
                </Text>
                <Text
                  className={clsx(
                    classes.value,
                    info.value.toLowerCase() === "completed"
                      ? classes.completed
                      : info.value.toLowerCase() === "pending"
                        ? classes.pending
                        : info.value.toLowerCase() === "active"
                          ? classes.active
                          : info.value.toLowerCase() === "failed"
                            ? classes.failed
                            : ""
                  )}
                  primitive800
                  base
                  semiBold
                >
                  {info.isBalance ? (
                    <span className={classes.balanceValue}>{info.value}</span>
                  ) : (
                    info.value
                  )}
                </Text>
              </div>
            ))}
          </div>
          <div className={classes.inputWrapper}>
            <Text lg primitive950>
              Enter Amount
            </Text>
            <Input
              value={amount}
              setValue={setAmount}
              type="number"
              onKeyDown={handleKeyDown}
              className={clsx(classes.input, classes.amountInput)}
              placeholder="0.00"
            />
          </div>
          <div className={classes.policyContainer}>
            {/* <Checkbox checked={agreeToPolicy} setChecked={setAgreeToPolicy} /> */}
            {/* <Text primitive700 base>
              I have read and agree with the{" "}
              <a
                href="#/"
                target="_blank"
                rel="noreferrer"
                className={classes.link}
              >
                Legal
              </a>{" "}
              and{" "}
              <a
                href="#/"
                target="_blank"
                rel="noreferrer"
                className={classes.link}
              >
                Policies
              </a>
              .
            </Text> */}
          </div>
          <div className={classes.buttonContainer}>
            <Button transparent onClick={onClose} className={classes.button}>
              Cancel
            </Button>{" "}
            <Button
              disabled={isLoading}
              onClick={async () => {
                if (isLoading) return;
                
                setIsLoading(true);
                try {
                  if (Number(amount) < Number(el?.minimum_amount)) {
                    toast.error("Amount must be greater than or equal to the minimum deposit amount");
                    setIsLoading(false);
                    return;
                  }
      
                  if (Number(amount) > Number(el?.maximum_amount)) {
                    toast.error("Amount must be less than or equal to the maximum deposit amount");
                    setIsLoading(false);
                    return;
                  }
      
                  if (Number(amount) > Number(userData?.balance)) {
                    toast.error("Insufficient balance");
                    setIsLoading(false);
                    return;
                  }
                  
                  let { data, status } = await open_position({
                    plan_id: el.id,
                    amount: Number(amount),
                  });
                  
                  if (status !== 200) {
                    toast.error(data);
                    setIsLoading(false);
                    return;
                  }
      
                  setNewInvestment(data);
                  if (data?.id) {
                    setShowTransactionDetailsModal(true);
                  }
                } catch (e) {
                  console.log("Error:", e);
                  toast.error(e);
                } finally {
                  setIsLoading(false);
                }
              }}
            >
              {isLoading ? "Processing..." : "Continue"}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreateInvestmentsModal;
